/****************************************************************************************************/
/* #region Mobile Menu Functinality */
/****************************************************************************************************/

var mobileMenu = function () {
  "use strict";

  // Private Properties
  var pageUrlPath = window.location.pathname;
  var selectedClassName = 'selected'; // the selected class name for menu items
  var selectedParentClassName = 'selected-parent'; // the selected class name for menu items
  var openStatusClassName = 'open';

  // Private Methods
  function init() {
    if ($('nav.mobileNav').length > 0) {
      // Select the nav item and add arrow div to each has-children link
      selectSectionNavItem();
      $('.mobileNavWrapper input[type="text"]').attr("placeholder", "Search");
    }
  }
  function onResize() {
    if ($('nav.mobileNav').length > 0 && window.innerWidth > 1024) {
      closeMenu();
    }
  }
  function selectSectionNavItem() {
    pageUrlPath = pageUrlPath === '/' ? '/home' : '/';
    $('nav.mobileNav').children().find('a[href$="' + pageUrlPath + '"], a[href$="' + pageUrlPath + '/"]').last().each(function () {
      findParentNavItem(this);
    });
  }
  function findParentNavItem(anchorElem) {
    if (anchorElem.href.indexOf(pageUrlPath) !== -1 && pageUrlPath !== '/') {
      // found the menu item
      $(anchorElem).parent().addClass(selectedClassName);
      highLightParentNavItem($(anchorElem).parent());
    }
  }
  function highLightParentNavItem(anchorElem) {
    var elem = $(anchorElem).closest('.hasChildren'); // find the closest previous .hasChildren and the anchor in that li and highlight it
    if (elem.length > 0 && !elem.hasClass(selectedParentClassName)) {
      elem.addClass(selectedParentClassName + ' ' + openStatusClassName);
      highLightParentNavItem(elem); // recursively call this function
    } else if (elem.length > 0) {
      // highlight the main nav item
      elem.parent().parent().closest('.hasChildren').addClass(selectedParentClassName); // needed to jump out of the 
    }
  }
  function isOpen() {
    return $('nav.mobileNav').hasClass(openStatusClassName);
  }
  function openMenu() {
    $('nav.mobileNav').css("visibility", "visible");

    // add nav-open classes
    $('.hamburger').addClass(openStatusClassName);
    $('nav.mobileNav').addClass(openStatusClassName);
    $('body, .mobileHeader').addClass('withNavOpen');

    // update aria atts
    $('.hamburger').attr("aria-expanded", true);
    focusFirstItem();
    // set focus on the menu
    //setTimeout(function () {
    //    // wait for the animation to finish
    //    //$('nav.mobile').find(":focusable").eq(0).focus(); // focus the first focusable element
    //}, 300);
  }
  function focusFirstItem() {
    var $focusables = $('nav.mobileNav').find(":focusable");
    //console.log({ $focusables });
    if ($focusables.length) {
      $focusables.eq(0).focus();
    }
  }
  function closeMenu() {
    // remove nav-open classes
    $('.hamburger').removeClass(openStatusClassName);
    $('nav.mobileNav').removeClass(openStatusClassName);
    $('body, .mobileHeader').removeClass('withNavOpen');

    // update aria atts
    $('.hamburger').attr("aria-expanded", false);

    // set focus back on the hamburger
    //$('.hamburger').first()[0].focus();
  }

  // Public Methods
  return {
    Init: function () {
      init();
    },
    OnResize: function () {
      onResize();
    },
    openMenu,
    closeMenu,
    isOpen
  };
}();

/* #endregion */
/****************************************************************************************************/

/****************************************************************************************************/
/* #region Initialize the menu and register events */
/****************************************************************************************************/

mobileMenu.Init();
$(window).on('resize', function () {
  mobileMenu.OnResize();
});

// close menu when clicking outside
$(window).on("click", function () {
  if (mobileMenu.isOpen()) {
    // Hide the menus if visible
    mobileMenu.closeMenu();
  }
});
$('.mobileHeader').on("click", function (e) {
  e.stopPropagation();
});

/* Escape-key support (for desktop uses of the mobile/hamburger menu) */
$(document).on("keydown", function (event) {
  if (mobileMenu.isOpen()) {
    if (event.keyCode === 27) {
      // escape key pressed so close the menu
      mobileMenu.closeMenu();
    }
  }
});
$('.hamburger').on("click", function (e) {
  if (mobileMenu.isOpen()) {
    mobileMenu.closeMenu();
  } else {
    mobileMenu.openMenu();
  }
  e.stopPropagation();
});

/* #endregion */
/****************************************************************************************************/